import {Injectable} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Brukerkontekst} from "./Brukerkontekst";
import {BrukerkontekstTilbyder} from "./BrukerkontekstTilbyder";
import {Kontekst} from "felles/tjenester/Kontekst";
import _ from "lodash";
import {Brukervalg} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";
import {kopierFraAjsTilNg2, kopierFraNg2TilAjs} from "felles-ng2/modell/ajsNg2ModellBroer";
import {AutentisertOkModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";

const debug = initDebugger('BrukerkontekstTilbyder');

/** Tjeneste for administrering av brukerkontekst.
 * Bruk {@link BrukerkontekstTilbyder} for å aksessere aktiv brukerkontekst */
@Injectable({providedIn: 'root'})
export class BrukerkontekstAdministrasjon {

    constructor(private brukerkontekst: BrukerkontekstTilbyder, private ajsKontekst: Kontekst) {
    }

    setAutentisertBruker(kontekst: Brukerkontekst) {
        debug('setAutentisertBruker', kontekst)
        this.brukerkontekst.setAutentisertBruker(kontekst);
    }

    /** markerer at bruker har logget ut */
    setBrukerLoggetUt() {
        debug('setBrukerLoggetUt')
        this.brukerkontekst.setBrukerLoggetUt();
    }

    relastBruker() {
        this.ajsKontekst.relastBruker();
    }

    relastKontekst() {
        this.ajsKontekst.relastBrukerOgGrupper();
    }

    oppdaterBrukervalg(brukervalg: Partial<Brukervalg>) {
        this.ajsKontekst.oppdaterBrukervalg(brukervalg as any); //oppdaterBrukervalg bruker l.Brukervalg, BrukerValg og l.Brukervalg er ikke kompatible pga ulike dato-typer
        //ajsKontekst.oppdaterBrukervalg oppdaterer ikke brukervalg satt på AutentisertOkModell, sørger her for å lage en kopi og oppdatere den med brukervalg
        const autentisert = kopierFraAjsTilNg2<AutentisertOkModell>(this.ajsKontekst.autentisert());
        //og så oppdatere BrukerkontekstTilbyder med oppdatert AutentisertOkModell
        this.setAutentisertBruker(new Brukerkontekst({...autentisert, brukervalg: kopierFraNg2TilAjs(this.ajsKontekst.brukervalg())}))
    }

    //hjelpemetoder
}
